// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { Button } from '@zapier/design-system';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';
import {
  loginPath,
  signupPath,
} from '@zapier/design-system-patterns/src/components/UniversalNav/constants';

import UniversalTopbarLink from './UniversalTopbarLink';

/** @jsx isolateComponent */

type Props = {|
  /**
   * `Href` to login button.
   */
  loginHref: string,
  /**
   * Currently navigated to url.
   */
  selectedHref: string,
  /**
   * Indicates whether Sign In button should render.
   */
  shouldRenderSignIn: boolean,
  /**
   * Indicates whether Sign Up button should render.
   */
  shouldRenderSignUp: boolean,
  /**
   * The size of the component, which influences the size of its buttons.
   */
  size: 'small' | 'medium',
  /**
   * `Href` to signup button.
   */
  signupHref: string,
|};

const Styles = labelStyles(__filename, {
  root: ({ itemsCount }) => [
    {
      alignItems: 'center',
      display: 'grid',
      gridGap: 20,
    },
    withModifier(`items-${itemsCount}`, {
      gridTemplateColumns: `repeat(${itemsCount}, max-content)`,
    }),
  ],
});

/**
 * Conditionally renders a login link and sign up button.
 */
export const AccountActions = (props: Props) => {
  const itemsCount =
    Number(props.shouldRenderSignIn) + Number(props.shouldRenderSignUp);
  return (
    <div css={Styles.root({ itemsCount })}>
      {props.shouldRenderSignIn && (
        <UniversalTopbarLink
          href={props.loginHref}
          isSelected={props.selectedHref.includes(props.loginHref)}
        >
          Sign In
        </UniversalTopbarLink>
      )}
      {props.shouldRenderSignUp && (
        <Button
          casing="uppercase"
          color="black"
          hasShadow={true}
          href={props.signupHref}
          id="universalnav-signup"
          size={props.size}
        >
          Sign Up
        </Button>
      )}
    </div>
  );
};

AccountActions.defaultProps = {
  loginHref: loginPath,
  selectedHref: '',
  signupHref: signupPath,
  size: 'medium',
};

export default AccountActions;
